/*
 * Copyright (c) 2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {Injectable, QueryList} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {Subject} from 'rxjs/Subject';

import {Alert} from '../alert';
export class MultiAlertService {
private allAlerts: QueryList<Alert> = new QueryList<Alert>();
private _current = 0;
/**
 * The Observable that lets other classes subscribe to changes
 */
private _change = new Subject<number>();
/**
 * @return {?}
 */
public get changes(): Observable<number> {
        return this._change.asObservable();
    }
/**
 * @return {?}
 */
get current() {
        return this._current;
    }
/**
 * @param {?} index
 * @return {?}
 */
set current(index: number) {
        if (index !== this._current) {
            this._current = index;
            this._change.next(index);
        }
    }
/**
 * @return {?}
 */
get activeAlerts() {
        return this.allAlerts.filter((alert) => !alert._closed);
    }
/**
 * @return {?}
 */
get currentAlert() {
        return this.activeAlerts[this.current];
    }
/**
 * @param {?} alert
 * @return {?}
 */
set currentAlert(alert: Alert) {
        this.current = this.activeAlerts.indexOf(alert);
    }
/**
 * @return {?}
 */
get count() {
        return this.activeAlerts.length;
    }
/**
 * @param {?} alerts
 * @return {?}
 */
manage(alerts: QueryList<Alert>) {
        this.allAlerts = alerts;
    }
/**
 * @return {?}
 */
next() {
        this.current = (this.current === this.activeAlerts.length - 1) ? 0 : this.current + 1;
    }
/**
 * @return {?}
 */
previous() {
        this.current = (this.current === 0) ? this.activeAlerts.length - 1 : this.current - 1;
    }
/**
 * @return {?}
 */
close() {
        this.previous();
    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MultiAlertService_tsickle_Closure_declarations() {
/** @type {?} */
MultiAlertService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MultiAlertService.ctorParameters;
/** @type {?} */
MultiAlertService.prototype.allAlerts;
/** @type {?} */
MultiAlertService.prototype._current;
/**
 * The Observable that lets other classes subscribe to changes
 * @type {?}
 */
MultiAlertService.prototype._change;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
